import vLink from './Link';

export { vLink };



// WEBPACK FOOTER //
// ./src/baseComponents/components/Link/index.js